<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <section class="basic-elements">
                            <div class="row">
                                <div class="col-sm-12">
                                    <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                                    <h2 class="content-header">{{ $t("labels.newArticle") }}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="px-3">
                                                <form class="form">
                                                    <news-form :article="article"></news-form>
                                                    <div class="form-actions">
                                                        <button type="button" class="btn btn-info mr-1" @click.prevent="back()">
                                                            <i class="fa fa-arrow-left"></i> {{ this.$t("labels.back") }}
                                                        </button>
                                                        <button type="button" class="btn btn-success" @click.prevent="saveArticle()">
                                                            <i class="icon-note"></i> {{ this.$t("labels.save") }}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsForm from '@/components/news/NewsForm'
import NewsService from '@/services/news'
import Progress from '@/components/patient/Progress.vue'

export default {
    components: {
        NewsForm,
        Progress
    },
    data() {
        return {
            errors: [],
            article: {
                title: '',
                body: '',
                slug: '',
                published: false,
                publishedAt: new Date(),
                metaTitle: '',
                metaDescription: '',
                image: ''
            }
        }
    },
    methods: {
        back() {
          this.$router.push({ name: 'home'})
        },
        saveArticle: async function() {
            this.errors = []
            let loader = this.$loading.show({
                color: '#ccc',
                loader: 'spinner'
            },{
                after: this.$createElement('Progress')
            })
            if (this.article.title.length == 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.title")]))
            }
            let slugRegex = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/
            if (this.article.slug.length == 0 || !this.article.slug.match(slugRegex)) {
                this.errors.push(this.$t("errors.slugInvalid"))
            }
            if (this.article.body.length == 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.articleBody")]))
            }
            if (this.errors.length === 0) {
                let formData = new FormData()
                formData.append('image', this.article.image)
                formData.append('article', JSON.stringify(this.article))
                let result = await NewsService.create(formData)
                if (result.data.success === true) {
                    this.$router.push({ name: 'newsList' })
                    this.$miniToastr.success(this.$t("flash.createSuccess"))
                } else {
                    for (let error in result.data.errors) {
                        this.errors.push(result.data.errors[error].msg)
                    }
                    this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                    this.errors = []
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                this.errors = []
            }
            loader.hide()
            this.$store.state.currentProgress = 0
        },
        back: function() {
           this.$router.push({ name: 'home' })
        }
    }
}
</script>

<style lang="scss">
    form {
        padding-top: 15px;
    }
</style>


